import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';

class StaffDesignationRevisionsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: this.props.staff_id,
      designation_id: null,
      designation_date: null,
      date_start: '',
      errors_listing: false,
      errors_messages: [],
      staff_designations: [],
      staff_designations_open: [],
      designation_observations: [],
      designations_list: [],
      lines: {},
      lines_open: {},
      staff_aircraft_models: {},
      staff_aircraft_models_open: {},
      staff_designations_open_info: {},
      staff_tasks: {},
      staff_tasks_open: {},
      staff_licenses: {},
      staff_licenses_open: {},
      staff_revisions: {},
      designation_observation_info: {},
      info: {},
      modal: false,
      modal_file: false,
      modal_open_revision: false,
      modal_observations: false,
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.closeRevision = this.closeRevision.bind(this);
    // this.deleteRevision = this.deleteRevision.bind(this);
    // this.openRevision = this.openRevision.bind(this);
    // this.deleteDesignation = this.deleteDesignation.bind(this);
    // this.deleteOpenItem = this.deleteOpenItem.bind(this);
    // this.editFile = this.editFile.bind(this);
    this.export = this.export.bind(this);
    this.viewObservations = this.viewObservations.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.staff_designations !== 'undefined' &&  typeof newProps.staff_designations_open !== 'undefined' && (this.state.loaded === 0 || (this.state.loaded === 1 && newProps.updated === 1))) {
      this.setState({
        staff_designations: newProps.staff_designations,
        staff_designations_open: newProps.staff_designations_open,
        staff_designations_open_info: newProps.staff_designations_open.info,
        lines: newProps.staff_designations.dlines,
        info: newProps.staff_designations.info,
        staff_aircraft_models: newProps.staff_designations.staff_aircraft_models,
        observations: newProps.staff_designations.info.staff_revision_observations,
        staff_tasks: newProps.staff_designations.staff_tasks,
        staff_licenses: newProps.staff_designations.staff_licenses,
        lines_open: newProps.staff_designations_open.dlines,
        staff_aircraft_models_open: newProps.staff_designations_open.staff_aircraft_models,
        observations_open: newProps.staff_designations_open.info.staff_revision_observations,
        staff_tasks_open: newProps.staff_designations_open.staff_tasks,
        staff_licenses_open: newProps.staff_designations_open.staff_licenses,
        designations_list: newProps.designations_list,
        staff_revisions: newProps.staff_revisions,
        staff_revisions_list: newProps.staff_revisions_list,
        loaded: 1
      });
    }
  }

  // Fetch salvando a edição
  // add(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     designation_id: this.state.designation_id,
  //     limitations: this.state.limitations,
  //     products: this.state.products,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/designacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       if (responseJson.status === 'success') {
  //         self.setState({loaded: 0});
  //         self.props.refreshData(responseJson);
  //       } else {
  //         self.setState({errors_messages: responseJson.data, errors_listing: true});
  //         self.props.refreshData(responseJson);
  //       }
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }

  // deleteDesignation(id) {
  //   if (window.confirm('Tem certeza que deseja deletar essa designação?')) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/designacao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({loaded: 0});
  //         self.props.refreshData(responseJson);
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  // deleteOpenItem(id, type) {
  //   if (window.confirm('Tem certeza que deseja deletar esse item da revisão de designação?')) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     let url = '/colaborador/revisao/frota/' + id;
  //     if (type === 'task') { url = '/colaborador/revisao/tarefa/' + id; }
  //     if (type === 'license') { url = '/colaborador/revisao/habilitacao/' + id; }
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + url, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({loaded: 0});
  //         self.props.refreshData(responseJson);
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  // closeRevision(event) {
  //   event.preventDefault();
  //   if (window.confirm('Tem certeza que deseja fechar essa revisão de designação?')) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       staff_revision_id: this.state.staff_designations_open.info.staff_revision_id,
  //       designation_date: this.state.designation_date,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/designacao/fechar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({modal: false});
  //         self.setState({loaded: 0});
  //         self.props.refreshData(responseJson);
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  // deleteRevision(event) {
  //   event.preventDefault();
  //   if (window.confirm('Tem certeza que deseja deletar essa revisão de designação?')) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       staff_revision_id: this.state.staff_designations_open.info.staff_revision_id,
  //       reason: this.state.delete_reason,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/designacao/deletar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({modal: false});
  //         self.setState({loaded: 0});
  //         self.props.refreshData(responseJson);
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  // openRevision(event) {
  //   event.preventDefault();
  //   if (window.confirm('Tem certeza que deseja abrir essa revisão de designação?')) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       staff_revision_id: this.state.staff_designations.info.staff_revision_id,
  //       reason: this.state.open_reason,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/designacao/abrir', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({modal_open_revision: false});
  //         self.setState({modal: false});
  //         self.setState({loaded: 0});
  //         self.props.refreshData(responseJson);
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  viewObservations(staff_revision_id) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/colaborador/designacao/observacoes/' + staff_revision_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({modal_open_revision: false});
        self.setState({modal: false});
        self.setState({modal_observations: true});
        self.setState({designation_observations: responseJson.data.main, designation_observation_info: responseJson.data.info});
        self.props.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // editFile(event) {
  //   event.preventDefault();
  //   var self = this;
  //   var data = new FormData();
  //   var import_data = document.querySelector('.import-data').files[0];
  //   data.append("file", import_data);
  //   data.append("staff_revision_id", this.state.staff_revision_file_id);
  //   var header = self.refs.request_api.header();
  //   self.props.handleAlert('', '', 'open');
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/importar/arquivo/designacao', { method: 'POST', mode: 'cors', headers: value, body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.setState({modal_file: false});
  //         self.setState({loaded: 0});
  //         self.props.refreshData(responseJson);
  //       }).catch((error) => {
  //         console.error(error);
  //     });
  //   });
  // }

  export(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
          self.props.handleAlert('', '', 'closed');
        }
      });
    });
  }
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div className="grid-buttons pull-right">
    {/* <button className="btn btn-warning" onClick={this.props.refreshData}><i className="fa fa-refresh"></i> Atualizar</button> */}
    {/* {
      (self.state.staff_designations_open_info.staff_revision_id === null) ? <button className="btn btn-default" onClick={() => {self.setState({modal_open_revision: true})}}><i className="fa fa-folder-open"></i> Abrir revisão {self.state.info.status}</button> : ''
    } */}

    <Dropdown id="export-data">
      <Dropdown.Toggle bsStyle={'info'}>
        <i className="fa fa-fw fa-file-pdf-o"></i> {this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.botaoExportacoes.ExportarDesignacoes}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {Object.keys(self.state.staff_revisions).map(function(k) {
          if (self.state.staff_revisions[k].type === 'export') {
            return (
              <MenuItem onSelect={self.export} eventKey={'/exportar/revisao/designacao/' + self.state.staff_revisions[k].id}>{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.botaoExportacoes.Revisao} {self.state.staff_revisions[k].number} - {self.state.staff_revisions[k].status_str}</MenuItem>
            );
          }
          if (self.state.staff_revisions[k].type === 'file') {
            return (
              <MenuItem href={config.get('cdn') + '/uploads/designations/' +  self.state.staff_revisions[k].file} target="_blank">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.botaoExportacoes.RevisaoArquivo(self.state.staff_revisions[k].number, self.state.staff_revisions[k].status_str)}</MenuItem>
            );
          }
          if (self.state.staff_revisions[k].type === 'observations') {
            return (
              <MenuItem onSelect={() => {self.viewObservations(self.state.staff_revisions[k].id)}}>{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.botaoExportacoes.RevisaoObservacoes(self.state.staff_revisions[k].number, self.state.staff_revisions[k].status_str)}</MenuItem>
            );
          }
        })}
      </Dropdown.Menu>
    </Dropdown>
    {/* <div className="btn-group">
      <button className="btn btn-primary" onClick={() => {self.setState({modal_file: true})}}><i className="fa fa-file-o"></i> Gravar PDF</button>
      <a className="btn btn-primary" href={config.get('cdn') + '/uploads/designations/' + self.state.info.file} target="_blank"><i className="fa fa-eye"></i></a>
    </div> */}
    {/* {(typeof this.state.lines_open === 'undefined') ?  ''
    :
      <button className="btn btn-success" onClick={() => {self.setState({modal: true})}}><i className="fa fa-edit"></i> Editar revisão aberta</button>
    } */}
  </div>
  <div className="clearfix"></div>
  <hr/>
  {(typeof this.state.lines === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.nenhumaDesignacaoCadastrada}</em></small><hr/></div>
  :
  <div>
    <h4>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloRevisao} {self.state.info.number} - {self.state.info.date_str}</h4>
    <h3></h3>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.Codigo}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.Designacao}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.DS}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.CEL}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.GMP}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.AVI}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.ProdutoEspecificacao}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.LimitacoesObservacoes}</th>
          {/* <th className="text-center"></th> */}
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.lines).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.lines[k].code}</td>
              <td className="text-center">{self.state.lines[k].name}</td>
              <td className="text-center">{self.state.lines[k].des}</td>
              <td className="text-center">{self.state.lines[k].cel}</td>
              <td className="text-center">{self.state.lines[k].gmp}</td>
              <td className="text-center">{self.state.lines[k].avi}</td>

                {(self.state.lines[k].products.no_act !== '') ?
                  <td className="text-center">
                    {self.state.lines[k].products.no_act}
                    {(self.state.lines[k].products.manual === 1) ? <span className="label label-danger">*</span> : ''}
                  </td>
                  :
                  <td className="text-center">
                  {(self.state.lines[k].products.am !== '') ?
                    <span> {self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.Acfts}:{self.state.lines[k].products.am}</span>
                    :
                    ''
                  }
                  {(self.state.lines[k].products.ams !== '') ?
                    <span> {self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.Eng}:{self.state.lines[k].products.ams}</span>
                    :
                    ''
                  }
                  {(self.state.lines[k].tasks.task !== '') ?
                    <span> {self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.Comp}:{self.state.lines[k].tasks.task}</span>
                    :
                    ''
                  }
                  </td>
                }
              <td className="text-center">{self.state.lines[k].limitations}</td>
              {/* <td className="text-center">
                  {(self.state.lines[k].id !== '') ?
                    <button className="btn btn-danger btn-sm" onClick={() => self.deleteDesignation(self.state.lines[k].id)}><i className="fa fa-fw fa-trash"></i></button>
                    :
                    ''
                  }
              </td> */}
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
  }
  <span className="label label-danger">*</span> {this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.designacoesComProdutoEspecificacaoEscritosManualmente}
  <hr/>
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloRazaoDeAberturaDaRevisao}</h3>
  <hr/>
  {(typeof this.state.info !== 'undefined') ?
    <h4>{this.state.info.reason}</h4>
  :
    <h4>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloRazaoNaoDisponivel}</h4>
  }
  <hr/>
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloHabilitacoesDesignadasDestaRevisao}</h3>
  <hr/>
  {(typeof this.state.staff_licenses === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.nenhumaHabilitacaoCadastrada}</em></small><hr/></div>
  :
  <table className="table table-bordered table-stripped table-hover">
    <thead>
      <tr>
        <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaHabilitacoesDesignadasDestaRevisao.Nome}</th>
        <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaHabilitacoesDesignadasDestaRevisao.Expiracao}</th>
      </tr>
    </thead>
    <tbody id="suppliers-certifications">
      {Object.keys(self.state.staff_licenses).map(function(k) {
        return (
          <tr>
            <td className="text-center">{self.state.staff_licenses[k].name}</td>
            <td className="text-center">{self.state.staff_licenses[k].expiration_str}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
  }
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloTarefasDesignadasDestaRevisao}</h3>
  <hr/>
  {(typeof this.state.staff_tasks === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.nenhumaTarefaCadastrada}</em></small><hr/></div>
  :
  <table className="table table-bordered table-stripped table-hover">
    <thead>
      <tr>
        <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaTarefasDesignadasDestaRevisao.Nome}</th>
        <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaTarefasDesignadasDestaRevisao.Expiracao}</th>
      </tr>
    </thead>
    <tbody id="suppliers-certifications">
      {Object.keys(self.state.staff_tasks).map(function(k) {
        return (
          <tr>
            <td className="text-center">{self.state.staff_tasks[k].name}</td>
            <td className="text-center">{self.state.staff_tasks[k].expiration_str}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
  }
  <hr/>
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloFrotasDesignadasDestaRevisao}</h3>
  <hr/>
  {(typeof this.state.staff_aircraft_models === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.nenhumaFrotaCadastrada}</em></small><hr/></div>
  :
  <table className="table table-bordered table-stripped table-hover">
    <thead>
      <tr>
        <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaFrotasDesignadasDestaRevisao.Nome}</th>
        <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaFrotasDesignadasDestaRevisao.Expiracao}</th>
      </tr>
    </thead>
    <tbody id="suppliers-certifications">
      {Object.keys(self.state.staff_aircraft_models).map(function(k) {
        return (
          <tr>
            <td className="text-center">{self.state.staff_aircraft_models[k].name}</td>
            <td className="text-center">{self.state.staff_aircraft_models[k].expiration_str}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
  }
  <hr/>
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloLogDeAcoesManuaisDestaRevisao}</h3>
  <hr/>
  {(typeof this.state.observations === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.nenhumaAcaoCadastrada}</em></small><hr/></div>
  :
  <table className="table table-bordered table-stripped table-hover">
    <thead>
      <tr>
        <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaLogDeAcoesManuaisDestaRevisao.Acao}</th>
        <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaLogDeAcoesManuaisDestaRevisao.Tipo}</th>
        <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaLogDeAcoesManuaisDestaRevisao.Usuario}</th>
        <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaLogDeAcoesManuaisDestaRevisao.Data}</th>
      </tr>
    </thead>
    <tbody id="suppliers-certifications">
      {Object.keys(self.state.observations).map(function(k) {
        return (
          <tr>
            <td className="text-center">{self.state.observations[k].observation}</td>
            <td className="text-center">{self.state.observations[k].type}</td>
            <td className="text-center">{self.state.observations[k].user_name}</td>
            <td className="text-center">{self.state.observations[k].created_at_str}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
  }
  {/* <hr/>
  <h3 className="page-title">Cadastrar designação</h3> */}
  <hr/>
  {this.state.errors_listing &&
    <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
      <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <strong>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.osColaboradorNaoPossuiOsCertificadosListadosAbaixo}:</strong>
      {Object.keys(self.state.errors_messages).map(function(k) {
        var message = self.state.errors_messages[k];
        return (
        <p>- {message}</p>
        );
      })}
    </div>
  }
  {/* <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Designação:</label>
        <Select
          className="form-field-name"
          name="designation_id"
          value={this.state.designation_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'designation_id')}
          options={this.state.designations_list}
        />
      </div>
      <div className="col-md-6 form-group">
        <label>Produto/Especificação:</label>
        <input type="text" className="form-control" name="products" value={this.state.products} onChange={this.handleChange.bind(this, 'products')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Limitações/Observações:</label>
        <input type="textarea" className="form-control" name="limitations" value={this.state.limitations} onChange={this.handleChange.bind(this, 'limitations')} />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar designação</button>
  </form> */}
  {/* <Modal show={self.state.modal_open_revision} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Abrir revisão {self.state.info.status}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_open_revision: false})}}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.openRevision}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Razão da abertura:</label>
            <input value={self.state.open_reason} name="open_reason" className="form-control" onChange={self.handleChange.bind(self, 'open_reason')} required placeholder="" />
          </div>
          <div className="col-md-6 form-group">
            <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-folder-open"></i> Abrir revisão de designação</button>
          </div>
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_open_revision: false})}}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={self.state.modal_file} aria-labelledby="contained-modal-alert-title-lg">
    <Modal.Header>
      <h4 className="pull-left">Editar arquivo da revisão fechada</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_file: false})}}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.editFile}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Arquivo:</label>
            <Select
              className="form-field-name"
              name="staff_revision_file_id"
              value={this.state.staff_revision_file_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'staff_revision_file_id')}
              options={this.state.staff_revisions_list}
              required
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Arquivo:</label>
            <input value={self.state.file} type="file" name="file" className="form-control import-data" onChange={self.handleChange.bind(self, 'file')} required placeholder="" />
          </div>
        </div>
        <div className="form-group">
          <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Salvar arquivo</button>
        </div>
      </form>
      <hr/>
      <small>A adição de um arquivo acarretará na substituição do arquivo anterior</small>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_file: false})}}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal> */}
  {/* <Modal show={self.state.modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Revisão {self.state.staff_designations_open.number} - ABERTA</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal: false})}}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.closeRevision}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Data da designação:</label>
            <InputMask value={self.state.designation_date}  maskChar={null} name="designation_date" mask="99/99/9999" className="form-control" onChange={self.handleChange.bind(self, 'designation_date')} required placeholder="" />
          </div>
          <div className="col-md-6 form-group">
            <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Fechar revisão de designação</button>
          </div>
        </div>
        <hr/>
      </form>
      <form onSubmit={this.deleteRevision}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Razão do fechamento:</label>
            <input value={self.state.delete_reason} name="delete_reason" className="form-control" onChange={self.handleChange.bind(self, 'delete_reason')} required placeholder="" />
          </div>
          <div className="col-md-6 form-group">
            <button type="submit" className="btn btn-danger btn-block btn-inline"><i className="fa fa-fw fa-trash"></i> Deletar revisão de designação</button>
          </div>
        </div>
        <hr/>
      </form>
      {(typeof this.state.lines_open === 'undefined') ?  <div><small><em>Nenhuma designação cadastrada.</em></small><hr/></div>
      :
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">Código</th>
            <th className="text-center">Designação</th>
            <th className="text-center">DS</th>
            <th className="text-center">CEL</th>
            <th className="text-center">GMP</th>
            <th className="text-center">AVI</th>
            <th className="text-center">Produto/Especificação</th>
            <th className="text-center">Limitações/Observações</th>
            <th className="text-center"></th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.lines_open).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.lines_open[k].code}</td>
                <td className="text-center">{self.state.lines_open[k].name}</td>
                <td className="text-center">{self.state.lines_open[k].des}</td>
                <td className="text-center">{self.state.lines_open[k].cel}</td>
                <td className="text-center">{self.state.lines_open[k].gmp}</td>
                <td className="text-center">{self.state.lines_open[k].avi}</td>

                  {(self.state.lines_open[k].products.no_act !== '') ?
                    <td className="text-center">
                      {self.state.lines_open[k].products.no_act}
                      {(self.state.lines_open[k].products.manual === 1) ? <span className="label label-danger">*</span> : ''}
                    </td>
                    :
                    <td className="text-center">
                    {(self.state.lines_open[k].products.am !== '') ?
                      <span> Acfts.:{self.state.lines_open[k].products.am}</span>
                      :
                      ''
                    }
                    {(self.state.lines_open[k].products.ams !== '') ?
                      <span> Eng.:{self.state.lines_open[k].products.ams}</span>
                      :
                      ''
                    }
                    {(self.state.lines_open[k].tasks.task !== '') ?
                      <span> Comp.:{self.state.lines_open[k].tasks.task}</span>
                      :
                      ''
                    }
                    </td>
                  }
                <td className="text-center">{self.state.lines_open[k].limitations}</td>
                <td className="text-center">
                    {(self.state.lines_open[k].id !== '') ?
                      <button className="btn btn-danger btn-sm" onClick={() => self.deleteDesignation(self.state.lines_open[k].id)}><i className="fa fa-fw fa-trash"></i></button>
                      :
                      ''
                    }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      }
      <span className="label label-danger">*</span> Designações com produto/especificação escritos manualmente
      <hr/>
      <h3 className="page-title">Razão de abertura da revisão</h3>
      <hr/>
      {(typeof this.state.staff_designations_open.info !== 'undefined') ?
        <h4>{this.state.staff_designations_open.info.reason}</h4>
      :
        <h4>Razão não disponível</h4>
      }
      <hr/>
      <h3 className="page-title">Habilitação designadas desta revisão</h3>
      <hr/>
      {(typeof this.state.staff_licenses_open === 'undefined') ?  <div><small><em>Nenhuma habilitação cadastrada.</em></small><hr/></div>
      :
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">Nome</th>
            <th className="text-center">Expiração</th>
            <th className="text-center"></th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.staff_licenses_open).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.staff_licenses_open[k].name}</td>
                <td className="text-center">{self.state.staff_licenses_open[k].expiration_str}</td>
                <td className="text-center"><button className="btn btn-danger" onClick={() => {self.deleteOpenItem(self.state.staff_licenses_open[k].id, 'license')}}><i className="fa fa-fw fa-trash"></i></button></td>
              </tr>
            );
          })}
        </tbody>
      </table>
      }
      <hr/>
      <h3 className="page-title">Tarefas designadas desta revisão</h3>
      <hr/>
      {(typeof this.state.staff_tasks_open === 'undefined') ?  <div><small><em>Nenhuma frota cadastrada.</em></small><hr/></div>
      :
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">Nome</th>
            <th className="text-center">Expiração</th>
            <th className="text-center"></th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.staff_tasks_open).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.staff_tasks_open[k].name}</td>
                <td className="text-center">{self.state.staff_tasks_open[k].expiration_str}</td>
                <td className="text-center"><button className="btn btn-danger" onClick={() => {self.deleteOpenItem(self.state.staff_tasks_open[k].id, 'task')}}><i className="fa fa-fw fa-trash"></i></button></td>
              </tr>
            );
          })}
        </tbody>
      </table>
      }
      <hr/>
      <h3 className="page-title">Frotas designadas desta revisão</h3>
      <hr/>
      {(typeof this.state.staff_aircraft_models_open === 'undefined') ?  <div><small><em>Nenhuma frota cadastrada.</em></small><hr/></div>
      :
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">Nome</th>
            <th className="text-center">Expiração</th>
            <th className="text-center"></th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.staff_aircraft_models_open).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.staff_aircraft_models_open[k].name}</td>
                <td className="text-center">{self.state.staff_aircraft_models_open[k].expiration_str}</td>
                <td className="text-center"><button className="btn btn-danger" onClick={() => {self.deleteOpenItem(self.state.staff_aircraft_models_open[k].id, 'aircraft_model')}}><i className="fa fa-fw fa-trash"></i></button></td>
              </tr>
            );
          })}
        </tbody>
      </table>
      }
      <hr/>
      <h3 className="page-title">Log de ações manuais desta revisão</h3>
      <hr/>
      {(typeof this.state.observations_open === 'undefined') ?  <div><small><em>Nenhuma ação cadastrada.</em></small><hr/></div>
      :
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">Ação</th>
            <th className="text-center">Tipo</th>
            <th className="text-center">Usuário</th>
            <th className="text-center">Data</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.observations_open).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.observations_open[k].observation}</td>
                <td className="text-center">{self.state.observations_open[k].type}</td>
                <td className="text-center">{self.state.observations_open[k].user_name}</td>
                <td className="text-center">{self.state.observations_open[k].created_at_str}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      }
      <hr/>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal: false})}}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={self.state.modal_observations} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Revisão {self.state.designation_observation_info.number}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_observations: false})}}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <h3 className="page-title">Log de ações manuais desta revisão</h3>
      <hr/>
      {(typeof this.state.designation_observations === 'undefined') ?  <div><small><em>Nenhuma ação cadastrada.</em></small><hr/></div>
      :
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">Ação</th>
            <th className="text-center">Tipo</th>
            <th className="text-center">Usuário</th>
            <th className="text-center">Data</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.designation_observations).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.designation_observations[k].observation}</td>
                <td className="text-center">{self.state.designation_observations[k].type}</td>
                <td className="text-center">{self.state.designation_observations[k].user_name}</td>
                <td className="text-center">{self.state.designation_observations[k].created_at_str}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      }
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_observations: false})}}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal> */}
</div>
    );
  }
}

export default StaffDesignationRevisionsTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffDesignationRevisionsTab.js